<template>
  <div class="contact-form">
    <FormComponent
      v-if="Object.keys(models).length"
      :models="activeModels"
      :hideCancel="true"
      @formSubmit="submitForm"
    />
  </div>
  <BlockLoader :loading="loading" />
</template>

<script>
import FormComponent from "@/components/FormComponent.vue";
import { formManager } from "@/services/form/form-manager";
import { apiConnection } from "@/services/api-connection";
import BlockLoader from "@/components/blocks/BlockLoader.vue";

export default {
  name: "TrainingSettingsComponent",
  components: { BlockLoader, FormComponent },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    models: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    activeModels() {
      const contactChildren = this.models.contact?.children ? Object.values(this.models.contact.children) : {};
      const settingsChildren = this.models.settings?.children ? Object.values(this.models.settings.children) : {};

      return [...contactChildren, ...settingsChildren];
    },
  },
  methods: {
    async submitForm() {
      const baseUrl = `/app/studea-manager/training/registration-settings/update/${this.$route.params.trainingId}`;

      const payload = {
        contact: formManager.processForm(this.models.contact?.children),
        settings: formManager.processForm(this.models.settings?.children),
      };

      this.loading = true;
      const data = await apiConnection.put(baseUrl, payload);
      formManager.processResponse(
        data,
        null,
        this.$t("global.edit.success", {
          name: this.$t("registration.registration_settings"),
        }),
        this.models,
      );
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form__title {
  margin-bottom: 20px;
}
.contact-form {
  padding: 10px;
}
</style>
